import axios from 'axios';
import { claimUpdatedThunk } from '../../../../../claim';
import { openDialogAction } from '../../../../../confirmation-dialog';
import { env } from '../../../../../env';
import { hideLoadingAction, showLoadingAction } from '../../../../../forms/loading-screen/actions';
import { ReduxThunkAction } from '../../../../../redux/redux-actions';

type VerifyStatusReturn = Promise<any>;
export type VerifyStatus = () => VerifyStatusReturn;
type VerifyStatusAction = () => ReduxThunkAction<VerifyStatusReturn>;

export const verifyStatusAction: VerifyStatusAction = () => {
    return async (dispatch, getState) => {
        dispatch(showLoadingAction());
        const claim = getState().claimSession.claim;
        const verifyUri = `${env().CLAIMS_API}/api/Claim/${claim.claimId}/VerifyStatus`;
        await axios
            .get(verifyUri)
            .then(response => {
                if (response.data) {
                    dispatch(claimUpdatedThunk(response.data));
                }
            })
            .catch(error => {
                let errorMessage = '';
                if (error.response) {
                    errorMessage = `Error Code ${error.response.status}`;
                } else {
                    errorMessage = error.message;
                }
                showErrorMessage(errorMessage);
            })
            .then(() => dispatch(hideLoadingAction()));

        function showErrorMessage(error: any) {
            const errorMessage = `An error (${error}) occured while verifying deceased status, please retry later`;
            dispatch(
                openDialogAction({
                    content: {
                        title: 'Error verify deceased status',
                        body: errorMessage,
                        error: true,
                    },
                })
            );
        }
    };
};
